import React, { useState, useEffect } from 'react'
import { Link } from 'gatsby'
import Layout from '../components/Layout'
import Seo from '../components/Seo'
import { downloadsURI, get_REST_API } from '../helper/handles'

const Downloads = () => {

	const [downloadData, setDownloadData] = useState([])

	useEffect(() => {
		get_REST_API(downloadsURI, res => {
			if (res?.name === 'Error') { }
			else { setDownloadData(res) }
		})
		return () => { }
	}, [])

	return (
		<Layout>
			<Seo title={`Downloads | NAC, Dharamgarh`} />
			<header className="header">
				<div className="header__jumbotron baseWrap df jcsb fww">
					<h2 className="sec_heading">Downloads</h2>
					<ol className="breadcrumb">
						<li className="breadcrumb-item">
							<Link to="/">Home</Link>
						</li>
						<li className="breadcrumb-item active">
							<span>Downloads</span>
						</li>
					</ol>
				</div>
			</header>
			<section className="sec sec_page df">
				<div className="baseWrap">
					<div className="contentWrap h100 ma shadow">
						<div className="collection-bordered">
							{
								downloadData && downloadData.length > 0 && downloadData.map((w, i) => (
									<div className="collection-item iconed" key={i}>
										<i className="material-icons-round">description</i>
										<div className="downloadItem">
											<p className="text">{w.title}</p>
											{w.file ? (<span className="df jcfe">
												<a href={w.file} download className="btn btn_icon sm">
													<i className="material-icons-round">save_alt</i>
													<span>Download</span>
												</a>
											</span>) : (<span></span>)}
										</div>
									</div>
								))
							}
						</div>
					</div>
				</div>
			</section>
		</Layout>
	)
}

export default Downloads
